import React, { useState } from 'react';
import Services from '../../Services/services';

export const CreatePassword = ({
  clientId,
  setPassword,
  validateLoginForm,
}) => {
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');

  const checkPasswordComplexity = (password) => {
    const passwordCriteria =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!#%*?&\-_=+.,:;<>/?[\]{}|`~^])[A-Za-z\d@$!#%*?&\-_=+.,:;<>/?[\]{}|`~^]{10,}$/;

    return passwordCriteria.test(password);
  };

  const handlePasswordChange = (e) => {
    const newPassword = e.target.value;
    setNewPassword(newPassword);
    // Check if confirmPassword has been entered and if it matches the new password
    if (confirmPassword && newPassword !== confirmPassword) {
      setPasswordError('Les mots de passe ne correspondent pas.');
    } else if (!checkPasswordComplexity(newPassword)) {
      setPasswordError(
        `Le mot de passe doit comporter au moins 10 caractères, dont une lettre minuscule, 
        une lettre majuscule, un chiffre et un caractère spécial.`
      );
    } else {
      setPasswordError('');
      setPassword(confirmPassword);
    }
  };

  const handleConfirmPasswordChange = (e) => {
    const newConfirmPassword = e.target.value;
    setConfirmPassword(newConfirmPassword);
    // Check if the password has been entered and if it matches the new confirmPassword
    if (newPassword && newPassword !== newConfirmPassword) {
      setPasswordError('Les mots de passe ne correspondent pas.');
    } else if (!checkPasswordComplexity(newConfirmPassword)) {
      setPasswordError(
        `Le mot de passe doit comporter au moins 10 caractères, dont une lettre minuscule, 
        une lettre majuscule, un chiffre et un caractère spécial.`
      );
    } else {
      setPasswordError('');
      setPassword(newConfirmPassword);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (passwordError) {
      return;
    }
    Services.profileService
      .createUserForClient(clientId, newPassword)
      .then(() => {
        validateLoginForm();
      })
      .catch((error) => console.error(error));
  };

  return (
    <>
      <span className="login-subtitle">
        <i>
          Afin de finaliser la création de votre compte, merci de saisir un mot
          de passe.
        </i>
      </span>
      <form className="login-container" onSubmit={handleSubmit}>
        <div className="password-container relative-container">
          <input
            type="password"
            id="password"
            name="password"
            className="contact-form-input"
            autoComplete="new-password"
            onChange={handlePasswordChange}
            value={newPassword}
            required
          />
          <label htmlFor="password" className="contact-form-label">
            Mot de passe
          </label>
        </div>
        <div className="password-container relative-container">
          <input
            type="password"
            id="confirmPassword"
            name="confirmPassword"
            className="contact-form-input"
            autoComplete="new-password"
            onChange={handleConfirmPasswordChange}
            value={confirmPassword}
            required
          />
          <label htmlFor="confirmPassword" className="contact-form-label">
            Confirmer le mot de passe
          </label>
        </div>
        {passwordError && <p style={{ color: 'red' }}>{passwordError}</p>}
        <button type="submit" className="btn-create-account">
          Valider mon mot de passe
        </button>
      </form>
    </>
  );
};

export default CreatePassword;
